import { KollectionType } from '@cyberkongz/api-interfaces';

const BASE_CDN_PATH = 'https://cyberkongz.fra1.cdn.digitaloceanspaces.com';

export function getVxPreviewImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview.jpg`;
}

export function getVxPreviewMediumImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_402x571.jpg`;
}

export function getVxPreviewSmallImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_164x232.jpg`;
}

export function getVxHeadImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_head.jpg`;
}

export function getVxHeadMediumImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_head_200x200.jpg`;
}

export function getVxHeadSmallImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_head_80x80.jpg`;
}

export function getVxBackImage(id: number) {
  return `${BASE_CDN_PATH}/public/${id}/${id}_preview_back.jpg`;
}

export function getGenesisImage(id: number) {
  return `${BASE_CDN_PATH}/site/assets/images/genesis/${id}.png`;
}

export function getBabyImage(id: number) {
  return `${BASE_CDN_PATH}/site/assets/images/baby/${id}.png`;
}

// TO DO UNIFY WITH API
type TribeType = 'Humba' | 'Bageni' | 'Kabirizi' | 'Senkwekwe' | 'Neo Kongz' | 'Rugendo';

const TRIBE_IMAGES: { [key in TribeType]: string } = {
  Humba: `${BASE_CDN_PATH}/site/assets/images/genkai/Humba_C.gif`,
  Bageni: `${BASE_CDN_PATH}/site/assets/images/genkai/Bageni_C.gif`,
  Kabirizi: `${BASE_CDN_PATH}/site/assets/images/genkai/Kabirizi_C.gif`,
  Senkwekwe: `${BASE_CDN_PATH}/site/assets/images/genkai/Senkwekwe_C.gif`,
  'Neo Kongz': `${BASE_CDN_PATH}/site/assets/images/genkai/NeoKongz_C.gif`,
  Rugendo: `${BASE_CDN_PATH}/site/assets/images/genkai/Rugendo_C.gif`,
};

type SizeGenkaiType = 'public' | '512' | '256';

export function getRevealedGenkaiImage(
  id: number,
  { size }: { size?: SizeGenkaiType } = { size: '512' }
) {
  return `${BASE_CDN_PATH}/genkai/public/${id}/${id}_${size}.jpg`;
}

type GetGenkaiImageOptions = {
  stage?: number;
  attributes?: PrismaJson.KongAttributesType | null;
  size?: SizeGenkaiType;
};

const getGenkaiImageDefaults: Required<GetGenkaiImageOptions> = {
  stage: 0,
  attributes: [],
  size: '512',
};

export function getGenkaiImage(id: number, options: GetGenkaiImageOptions = {}) {
  const { stage, attributes: _attributes, size } = { ...getGenkaiImageDefaults, ...options };

  const attributes = _attributes || [];

  if (stage === 0) {
    const kongTribe = attributes.find((item) => item.trait_type === 'Tribe')?.value as TribeType;
    const isRonOrigin = attributes.find((item) => item.trait_type === 'Origin')?.value === 'Ronin';

    return TRIBE_IMAGES[kongTribe].replace('_C', isRonOrigin ? '_RON' : '_ETH');
  }

  return getRevealedGenkaiImage(id, { size });
}

export function getKongImageByType(
  id: number,
  type: KollectionType,
  options?: {
    sizeVX?: 'medium' | 'small';
    partVX?: 'head';
    stageGenkai?: number;
    attributesGenkai?: PrismaJson.KongAttributesType;
    sizeGenkai?: SizeGenkaiType;
  }
) {
  return type === 'genesis'
    ? getGenesisImage(id)
    : type === 'baby'
    ? getBabyImage(id)
    : type === 'genkai'
    ? getGenkaiImage(id, {
        stage: options?.stageGenkai,
        attributes: options?.attributesGenkai,
        size: options?.sizeGenkai,
      })
    : options?.sizeVX === 'medium'
    ? getVxPreviewMediumImage(id)
    : options?.partVX === 'head'
    ? getVxHeadSmallImage(id)
    : getVxPreviewSmallImage(id);
}
